import { recognition } from "./index.js";

export const thePrompt = [
  {
    role: "system",
    content:
      //OLD: "You receive texts from speech recognition and convert them to commands by following the examples. If the texts you receive are in a language other than English, you just translate to English and then execute. If you don't understand the request, you run the command didntUnderstand(). The only functions you can output are countAtoms(), greetHello(), greetBye(), acknowledge(), sayTime(), sayDate(), zoomIn(), zoomOut(), changeTemperature(), setTemperature(), startSimulation(), stopSimulation(), writePDB(), select(), spacefill, sticks, color, and didntUnderstand(). For requests without any close examples, you do smart conversions, for example 'cartoon' refers to using a backbone selection and then applying 'spacefill 1; sticks 2'. Make sure you don't use things that don't exist, such as color byref.",
      "You receive texts from speech recognition and convert them to commands by following the examples. If the texts you receive are in a language other than English, you just translate to English and then execute. If you don't understand the request, you run the command didntUnderstand(). The only functions you can output are countAtoms(), greetHello(), greetBye(), acknowledge(), sayTime(), sayDate(), zoomIn(), zoomOut(), changeTemperature(), changeUpdateRate(), setTemperature(), startSimulation(), stopSimulation(), writePDB(), select(), changeUpdateRate(), speakUp(), rotate(), rotateTo(), logTrajectory(), spacefill, sticks, color, and didntUnderstand(). For requests without any close examples, you do smart conversions, for example 'cartoon' refers to using a backbone selection and then applying 'spacefill 1; sticks 2'. Make sure you don't use things that don't exist, such as color byref. For requests without any close examples, you do smart conversions, for example 'cartoon' refers to atoms that make up a backbone, such as N, C and CA atoms in proteins or P atoms in nucleic acids. Note that some words might be wrong in the input provided due to errors upon speech recognition, for example 'some' might need to be replaced by 'zoom', 'so mean' could be 'zoom in', 'change' might actually be 'chain' or 'chains', 'handball' would actually be 'HandMol', 'mini mice' would be 'minimize', etc.",
  },

  //General conversation
  { role: "user", content: "Hello man" },
  { role: "assistant", content: "//Simply greet\ngreetHello();" },
  { role: "user", content: "Good bye" },
  { role: "assistant", content: "//Simply greet\ngreetBye();" },
  { role: "user", content: "Thanks" },
  { role: "assistant", content: "//Acknowledge to keep chat flowing\nacknowledge('You're welcome.');" },
  { role: "user", content: "Super, merci" },
  { role: "assistant", content: "//Always use functions that output strings, i.e. acknowledge(), greetHello(), greetBye() and speakUp(), in the user's language\nacknowledge('De rien!');" },
/*  { role: "user", content: "Chau!" },
  { role: "assistant", content: "//Simply greet; the input was in Spanish so we reply in Sp\ngreetBye();" },   */  //usar solo speakup() ??  ****HOLA
  { role: "user", content: "Good well done" },
  { role: "assistant", content: "//Acknowledge to keep chat flowing\nacknowledge('My pleasure.');" },
  { role: "user", content: "What time is it?" },
  { role: "assistant", content: "//Use sayTime() function\nsayTime();" },
  { role: "user", content: "What's the date today?" },
  { role: "assistant", content: "//Use sayDate() function\nsayDate();" },
  { role: "user", content: "What's the date and time?" },
  { role: "assistant", content: "//First call sayDate() and then sayTime()\nsayDate();sayTime();" },

  //Info about the system
  { role: "user", content: "Tell me the number of atoms" },
  { role: "assistant", content: "//Use countAtoms()\ncountAtoms();" },
  { role: "user", content: "How many atoms are there?" },
  { role: "assistant", content: "//Use countAtoms()\ncountAtoms();" },

  //Info about the app and molecular graphics
  { role: "user", content: "Tell me about this software." },
  {
    role: "assistant",
    content:
      "//Explain what HandMol is and what it does, displaying the output via the speakUp() function\nspeakUp('HandMol is a software for interactive, multiuser, immersive molecular graphics and modeling. It was developed by Fabio Cortés Rodríguez, Lucien Krapp and Luciano Abriata from EPFL, Switzerland.')",
  },
  { role: "user", content: "What is this HandMol thing?" },
  {
    role: "assistant",
    content: "//This was a different way to ask about the program, and here we provide a shorter answer, again displayed with the speakUp() function\nspeakUp('HandMol is a web platform for multiuser immersive molecular graphics and modeling.')",
  },
  { role: "user", content: "Who developed it?" },
  {
    role: "assistant",
    content:
      "//Clearly referring to this program HandMol, as the conversation goes; so we reply accordingly using the speakUp() function\nspeakUp('HandMol was developed at the Swiss Federal Institute of Technology Lausanne (EPFL) by Fabio Cortes Rodriguez (main server, WebXR experiences, interface and platform architecture), Lucien Krapp (OpenMM engines and ANI endpoint), and Luciano Abriata (lamguage models, resources and funding, project coordination).')",
  },
  { role: "user", content: "What kinds of questions can I ask?" },
  {
    role: "assistant",
    content:
      '//Again the user is simply asking for general information about the program, so we reply using speakUp()\nspeakUp(\'You can ask questions such as "Please show the protein as cartoons and the ligands as spheres." or "Increase temperature.", etc. Please check the examples.\')',
  },
  { role: "user", content: "Can you add or delete atoms or molecules?" },
  {
    role: "assistant",
    content:
      "//Again user asked about the app, so we reply with speakUp()\nspeakUp('No, I can't add or delete atoms or molecules. You can however break molecules apart (and also build them) in the ANI engine.'",
  },
  { role: "user", content: "What are the standard CPK colors?" },
  {
    role: "assistant",
    content:
      "//Explain the CPK color scheme of atom colors, using the speakUp() function\nspeakUp('In the CPK scheme, carbon atoms are grey, nitrogens are blue, oxygens are red, hydrogens are white, sulphur atoms are yellow, and fluorine and chlorine are of different hues of green.')",
  },

  //Zooming
  { role: "user", content: "Make molecules bigger" },
  { role: "assistant", content: "//Use the zoomIn() function\nzoomIn();" },
  { role: "user", content: "More" },
  { role: "assistant", content: "//Repeat the previous action\nzoomIn();" },
  { role: "user", content: "Make it bigger" },
  { role: "assistant", content: "//Also repeat previous action\nzoomIn();" },
  { role: "user", content: "Zoom in" },
  { role: "assistant", content: "//Another way to ask the same so again zoomIn() is executed\nzoomIn();" },
  { role: "user", content: "Scale up" },
  { role: "assistant", content: "//Yet another way to ask the same\nzoomIn();" },
  { role: "user", content: "Zoom in a lot" },
  { role: "assistant", content: "//Just call zoomIn() multiple times\nzoomIn();zoomIn();zoomIn();zoomIn();zoomIn();" },
  { role: "user", content: "Make molecules smaller" },
  { role: "assistant", content: "//Opposite to the previous examples, so now we call zoomOut()\nzoomOut();" },
  { role: "user", content: "Zoom out" },
  { role: "assistant", content: "zoomOut();" },
  { role: "user", content: "Again" },
  { role: "assistant", content: "zoomOut();" },
  { role: "user", content: "Scale down" },
  { role: "assistant", content: "zoomOut();" },
  { role: "user", content: "Zoom out many times" },
  { role: "assistant", content: "//Analogous to one of the last examples, now we call zoomOut() multiple times\nzoomOut();zoomOut();zoomOut();zoomOut();zoomOut();" },
  { role: "user", content: "Do faster updates" },
  { role: "assistant", content: "//Users asks for faster updates of the simulation as it is sent from the server to the app, so we increase the update rate\nchangeUpdateRate(1);" },
  { role: "user", content: "Do slower updates" },
  { role: "assistant", content: "//Opposite to above, which might be needed when wifi bandwith is low and/or simulated system is too big\nchangeUpdateRate(-1);" },
  { role: "user", content: "The simulation is laggy, what can I do?" },
  { role: "assistant", content: "//Decreasing the update rate can help, so we explain this using speakUp() and decrease the update rate\nspeakUp('This can happen if the wifi speed is low and/or if the system is too big. I'll try reducing the update rate by 3 units.');changeUpdateRate(-3);" },
  { role: "user", content: "Zoom in and make more fluid updates" },
  { role: "assistant", content: "//Example of how to combine function calls when multiple things are asked together\nzoomIn();changeUpdateRate(1);" },

  //Simulation controls
  { role: "user", content: "Increase temperature" },
  { role: "assistant", content: "//There's a specific command to change temperature by a value, and another to set the temperature to a given value. This request asks for an increase, so we use changeTemperature() passing a positive number\nchangeTemperature(+30);" },
  { role: "user", content: "Again" },
  { role: "assistant", content: "//Same here\nchangeTemperature(+30);" },
  { role: "user", content: "Decrease temperature" },
  { role: "assistant", content: "//Now a negative change is needed\nchangeTemperature(-30);" },
  { role: "user", content: "Change temperature by +20 degrees" },
  { role: "assistant", content: "//Now a specific change is asked, so we pass this to the changeTemperature() function\nchangeTemperature(+20);" },
  { role: "user", content: "Make it cooler by 10 degrees" },
  { role: "assistant", content: "//A different way to ask for a specific change in temperature\nchangeTemperature(-10);" },
  { role: "user", content: "Lower temperature by 50 degrees" },
  { role: "assistant", content: "//Yet another way\nchangeTemperature(-50);" },
  { role: "user", content: "Set temperature to 298 kelvin" },
  { role: "assistant", content: "//Here the user asked for a specific temperature, so we use setTemperature\nsetTemperature(298);" },
  { role: "user", content: "Set temperature to 37 degrees Celsius" },
  { role: "assistant", content: "//Same, but we convert from Celsius to Kelvin as this is required as the argument for setTemperature\nsetTemperature(310);" },
  { role: "user", content: "Start simulation" },
  { role: "assistant", content: "//User asked to start the simulation, so we call startSimulation()\nstartSimulation();" },
  { role: "user", content: "Stop simulation" },
  { role: "assistant", content: "//User asked to stop (pause) the simulation\nstopSimulation();" },
  { role: "user", content: "Keep going" },
  { role: "assistant", content: "//From context, 'keep going' means the simulation that was paused must continue playing\nstartSimulation();" },
  { role: "user", content: "Freeze simulation" },
  { role: "assistant", content: "//This could have also been interpreted as a request to take the temperature to zero, but stopping the simulation is faster so we run stopSimulation(); anyway, we inform the user via speakUp() that if setting the temperature to zero was intended, then this should be asked or done specifically\nstopSimulation();speakUp('If you meant to take the simulation temperature to 0 K, do this on the Simulations menu or ask me this specifically.')" },
  { role: "user", content: "Freeze atoms" },
  { role: "assistant", content: "//Same as in last case\nstopSimulation();speakUp('If you meant to take the simulation temperature to 0 K, do this on the Simulations menu or ask me this specifically.')" },
  { role: "user", content: "Resume simulation" },
  { role: "assistant", content: "startSimulation();" },
  { role: "user", content: "Continue simulation" },
  { role: "assistant", content: "startSimulation();" },
  { role: "user", content: "Restart simulation" },
  { role: "assistant", content: "startSimulation();" },
  { role: "user", content: "Write the coordinates" },
  { role: "assistant", content: "//Call the writePDB() function\nwritePDB();" },
  { role: "user", content: "Write PDB" },
  { role: "assistant", content: "writePDB();" },
  { role: "user", content: "Save coordinates" },
  { role: "assistant", content: "writePDB();" },
  { role: "user", content: "Export the coordinates" },
  { role: "assistant", content: "writePDB();" },
  { role: "user", content: "Start logging coordinates every 1 second" },
  { role: "assistant", content: "//Call logTrajectory() but note that the time must be past in milliseconds\nlogTrajectory(1000);" },
  { role: "user", content: "Stop logging the trajectory" },
  { role: "assistant", content: "logTrajectory(FALSE);" },

  //Visualization
  { role: "user", content: "Show all positively charged residues as spheres" },
  { role: "assistant", content: "//Simply select the positively charged amino acids, that is ARG and LYS, and show them as spheres for which we use size 3 with 'spacefill 3'\nselect('resname ARG LYS'); spacefill 3;" },
  { role: "user", content: "Make those spheres bigger" },
  { role: "assistant", content: "//User specifically asked for the spheres to be bigger, so we now do 'spacefill 6'; note that the selection needs to be done again\nselect('resname ARG LYS'); spacefill 3;" },
  { role: "user", content: "Show aromatic residues as sticks" },
  { role: "assistant", content: "//Analogously, here we select the aromatic residues and show them as sticks; but in order for the effect to be clear, we must make any large spheres invisible by using 'spacefill 0' besides showing the sticks with 'sticks 1'\nselect('resname PHE TYR TRP HIS'); spacefill 0; sticks 1;" },
  { role: "user", content: "Show hydrophobic amino acids as spheres" },
  { role: "assistant", content: "//Similarly here, we select the hydrophobic residues and show them as spheres with 'spacefill 3'\nselect('resname ALA VAL LEU ILE PRO PHE MET TRP'); spacefill 3;" },
  { role: "user", content: "Show residues 13 to 20 as balls and sticks" },
  { role: "assistant", content: "//In this case we select a range of residues, and then to show 'balls and sticks' we need spheres of size 1 with 'spacefill 1' and sticks with 'sticks 1'\nselect('resid 13 to 20'); spacefill 1; sticks 1;" },
  { role: "user", content: "Show residue 237 as spheres" },
  { role: "assistant", content: "//Following a similar reasoning as before, when spheres are asked we use 'spacefill 3' after doing the selection\nselect('resid 237'); spacefill 3;" },
  { role: "user", content: "Show everything as sticks" },
  { role: "assistant", content: "//As before, we select in this case all atoms and then hide the spheres and show the sticks\nselect('all'); spacefill 0; sticks 1;" },
  { role: "user", content: "Select all negative amino acid" },
  { role: "assistant", content: "select('resname ASP GLU');" },
  { role: "user", content: "Display the selection as sticks" },
  { role: "assistant", content: "//As always, we re do the selection; we then apply the visualization commands which as in previous examples here involve hiding the spheres and showing the sticks\nselect('resname ASP GLU');spacefill 0; sticks 1;" },
  { role: "user", content: "Show chain A as spheres and chain B as sticks" },
  { role: "assistant", content: "select('chain A'); spacefill 3; select('chain B'); spacefill 0; sticks 1;" },
  { role: "user", content: "Show their hydrogens" },
  { role: "assistant", content: "//Their refers to the previous selection, which involved chains A and chain B, so we do the corresponding selection and then show the selected atoms as balls and sticks which is the most standard way to show atoms when nothing is specified\nselect('chain A B and element H'); spacefill 1; sticks 1;" },
  { role: "user", content: "Show glutamates and glutamines as spheres" },
  { role: "assistant", content: "select('residue GLU GLN'); spacefill 3;" },
  { role: "user", content: "Hide all spheres" },
  { role: "assistant", content: "//'All spheres' likely refers to literally all the atoms, so we select 'all' and then hide the spheres with 'spacefill 0' as usual, and don't do anything with the sticks as nothing is instructed\nselect('all'); spacefill 0;" },
  { role: "user", content: "Hide all atoms" },
  { role: "assistant", content: "//Same but this time we hide the sticks too, so that nothing is seen for the atoms\nselect('all'); spacefill 0; sticks 0;" },
  { role: "user", content: "Hide hydrogens in chain A." },
  { role: "assistant", content: "select('element H and chain A'); spacefill 0; sticks 0;" },
  { role: "user", content: "Hide all hydrogens" },
  { role: "assistant", content: "select('element H'); spacefill 0; sticks 0;" },
  { role: "user", content: "Hide membrane" },
  { role: "assistant", content: "select('membrane'); spacefill 0; sticks 0;" },
  { role: "user", content: "Color all atoms in magenta" },
  { role: "assistant", content: "select('all'); color magenta;" },
  { role: "user", content: "Show positive residues in blue" },
  { role: "assistant", content: "select('resname LYS ARG'); color blue;" },
  { role: "user", content: "Highlight residue number 1" },
  { role: "assistant", content: "//To highlight an atom we make its sphere bigger, so 'spacefill 3' goes here\nselect('resid 1'); spacefill 3; sticks 1;" },
  { role: "user", content: "No wait but show it in red" },
  { role: "assistant", content: "//Notice we first re-select the atoms, and then apply the color\nselect('resid 1'); color red;" },
  { role: "user", content: "Hide the H atoms and show all others as spheres" },
  { role: "assistant", content: "//We must first show all as spheres and then hide the H atoms, because if we do the other way around, the H atoms will end up as spheres too!\nselect('all'); spacefill 3; select('element H'); spacefill 0;" },     ///****WOULD CHANGE WITH A BETTER SELECTION PARSER */

  { role: "user", content: "Color by charge" },
  {
    role: "assistant",
    content: "//As nothing is specified, we select all atoms--but this could be interpreted differently in other contexts. We then set them all to white and then do specific selections plus coloring to complete the request of coloring by charge\nselect('all'); color white; select('resname ASP GLU'); color red; select('resname ARG LYS'); color blue;",
  },
  { role: "user", content: "Color chain C by charge" },
  {
    role: "assistant",
    content:
      "//Select chain C specifically and then apply the standard color charges for amino acids\nselect('chain C'); color white; select('resname ASP GLU and chain C'); color red; select('resname ARG LYS and chain C'); color blue;",
  },

  { role: "user", content: "Color by amino acid type" },
  {
    role: "assistant",
    content:
      "//Similar to above, but assuming no special selection was done before (if one was done we must first account for that!), we first color all atoms white and then go through the different kinds of residue types that HandMol knows, coloring them as follows: negative amino acids in red, positive amino acids in blue, polar uncharged amino acids in green, proline in black, hydrophobic non-aromatic in gray, aromatic in purple\nselect('all'); color white; select('resname ASP GLU'); color red; select('resname ARG LYS'); color blue; select('resname SER THR CYS ASN GLN GLY'); color green; select('resname PRO'); color black; select('resname ALA VAL ILE LEU MET'); color gray; select('resname HIS PHE TYR TRP'); color purple;",
  },      //COMPLETE WITH MORE RESTYPES --AND THEN MODIFY THE TWO NEXT *****HOLA
  { role: "user", content: "Color by residue type." },
  {
    role: "assistant",
    content:
      "//Same as previous case\nselect('all'); color white; select('resname ASP GLU'); color red; select('resname ARG LYS'); color blue; select('resname SER THR CYS ASN GLN GLY'); color green; select('resname PRO'); color black; select('resname ALA VAL ILE LEU MET'); color gray; select('resname HIS PHE TYR TRP'); color purple;",
  },
  { role: "user", content: "Color by properties" },
  {
    role: "assistant",
    content:
      "Same as previous case\nselect('resname ASP GLU'); color red; select('resname ARG LYS'); color blue; select('resname SER THR CYS ASN GLN GLY'); color green; select('resname PRO'); color black; select('resname ALA VAL ILE LEU MET'); color gray; select('resname HIS PHE TYR TRP'); color purple;",
  },
  { role: "user", content: "Color residues by type" },
  {
    role: "assistant",
    content:
      "select('resname ASP GLU'); color red; select('resname ARG LYS'); color blue; select('resname SER THR CYS ASN GLN GLY'); color green; select('resname PRO'); color black; select('resname ALA VAL ILE LEU MET'); color gray; select('resname HIS PHE TYR TRP'); color purple;",
  },

  { role: "user", content: "Color proteins by B factor" },
  { role: "assistant", content: "//Select proteins and then color by B-factor\nselect('protein'); color bfactor;" },
  { role: "user", content: "Color chain B as rainbow" },
  { role: "assistant", content: "select('chain B'); color rainbow;" },
  { role: "user", content: "Color protein from blue to red" },
  { role: "assistant", content: "//Blue to red, rainbow, or by residue number are all the same coloring scheme\nselect('protein'); color rainbow;" },
  { role: "user", content: "Show arginines as huge cyan spheres" },
  { role: "assistant", content: "//User asked for giant sphere, so after doing the selection we use 'spacefill 5' (and bigger could be used if requested, too)\nselect('resname ARG'); spacefill 5; color cyan;" },
  { role: "user", content: "Use standard atom colors for chain B" },
  { role: "assistant", content: "'color cpk' is the standard set of atom colors\nselect('chain B'); color cpk;" },
  { role: "user", content: "Apply standard color scheme to all atoms" },
  { role: "assistant", content: "//Since no special selection is requested, we here select all atoms, but this could depend on context\nselect('all'); color cpk;" },
  { role: "user", content: "Color hydrogens, nitrogens and carbons by CPK" },
  { role: "assistant", content: "select('element H N C'); color cpk;" },
  { role: "user", content: "Color by chain" },
  { role: "assistant", content: "select('all'); color chain;" },
  { role: "user", content: "Reset colors" },
  { role: "assistant", content: "select('all'); color cpk;" },
  { role: "user", content: "Reset the view" },
  { role: "assistant", content: "//User likely just wants to see everything as it was when the session started, which means all atoms as balls and sticks using CPK colors\nselect('all'); spacefill 1; sticks 1; color cpk;" },
  { role: "user", content: "Show nucleic acids as spheres" },
  { role: "assistant", content: "select('nucleic'); spacefill 3;" },
  { role: "user", content: "Show DNA as red spheres" },
  { role: "assistant", content: "select('dna'); spacefill 3; color red;" },
  { role: "user", content: "Show RNA as sticks in standard colors" },
  { role: "assistant", content: "select('rna'); spacefill 0; sticks 1; color cpk;" },
  { role: "user", content: "Show backbone only for all molecules" },
  { role: "assistant", content: "//Backbone is the same as cartoons, both referring to showing only the backbone skeleton of proteins and nucleic acids; since 'only backbone' for 'all molecules' is specified, we first hide all atoms and then select the backbone and show it with balls and thick sticks hence 'sticks 2'\nselect('all'); spacefill 0; sticks 0; select('backbone'); spacefill 1; sticks 2;" },
  { role: "user", content: "Show chains A and B as cartoons" },
  {
    role: "assistant",
    content: "//Nothing is specified about other molecules, so we select chains A and B, hide their atoms, then select their backbones and show them with thick sticks\nselect('chain A B'); spacefill 0; sticks 0; select('chain A B and backbone'); spacefill 1; sticks 2;",
  },
  { role: "user", content: "Show sidechains as spheres" },
  { role: "assistant", content: "//All sidechains assumed, but could have been differently depending on context\nselect('sidechain'); spacefill 3;" },
  { role: "user", content: "Show protein backbone as cartoons" },
  {
    role: "assistant",
    content: "//First hide all protein representations, then show the protein backbones as cartoons\nselect('protein'); spacefill 0; sticks 0; select('protein and backbone'); spacefill 1; sticks 2;",
  },
  { role: "user", content: "Show everything as cartoons" },
  { role: "assistant", content: "//Hide all representations for all atoms, then show backbones as cartoons\nselect('all'); spacefill 0; sticks 0; select('backbone'); spacefill 1; sticks 2;" },
  { role: "user", content: "Show all ligands in chain A as cpk spheres" },
  { role: "assistant", content: "select('ligand and chain A'); spacefill 3; color cpk;" },
  { role: "user", content: "Show small molecules as spheres" },
  { role: "assistant", content: "select('ligand'); spacefill 3;" },
  { role: "user", content: "Hide water molecules" },
  { role: "assistant", content: "select('water'); spacefill 0; sticks 0;" },
  { role: "user", content: "Show waters as thin lines" },
  { role: "assistant", content: "select('water'); spacefill 0; sticks 0.1;" },
  { role: "user", content: "Show only nucleic acids" },
  { role: "assistant", content: "//Balls and sticks assumed, as nothing is specified, but first we hide everything\nselect('all'); spacefill 0; sticks 0; select('nucleic'); spacefill 1; sticks 1;" },

  { role: "user", content: "Make spheres bigger" },
  { role: "assistant", content: "//As no specific atoms or molecules are indicated, we select all and increase the radius\nselect('all'); spacefill 3;" },
  { role: "user", content: "Much bigger" },
  { role: "assistant", content: "select('all'); spacefill 6;" },
  { role: "user", content: "Rotate 90 degrees around x" },
  { role: "assistant", content: "//This implies a rotation from its current orientation, so we use rotate(), and note it takes arguments in radians\nrotate(1.57,0,0)" },
  { role: "user", content: "Reset rotation" },
  { role: "assistant", content: "//This requires setting absolute angles, so we need to use rotateTo(), and note it takes arguments in radians\nrotateTo(0,0,0)" },
];

export function selectAtoms(selection, pdb) {
  // List of residue names representing protein amino acids
  const proteinResidues = [
    "ALA",
    "CYS",
    "ASP",
    "GLU",
    "PHE",
    "GLY",
    "HIS",
    "ILE",
    "LYS",
    "LEU",
    "MET",
    "ASN",
    "PRO",
    "GLN",
    "ARG",
    "SER",
    "THR",
    "VAL",
    "TRP",
    "TYR",
  ];
  const nucleicResidues = [
    "DA",
    "DA3",
    "DA5",
    "DAN",
    "DC",
    "DC3",
    "DC5",
    "DCN",
    "DG",
    "DG3",
    "DG5",
    "DGN",
    "DT",
    "DT3",
    "DT5",
    "DTN",
    "GUA",
    "CYT",
    "URA",
    "ADE",
    "A",
    "A3",
    "A5",
    "AN",
    "C",
    "C3",
    "C5",
    "CN",
    "G",
    "G3",
    "G5",
    "GN",
    "OHE",
    "U",
    "U3",
    "U5",
    "UN",
  ];
  const dnaResidues = [
    "DA",
    "DA3",
    "DA5",
    "DAN",
    "DC",
    "DC3",
    "DC5",
    "DCN",
    "DG",
    "DG3",
    "DG5",
    "DGN",
    "DT",
    "DT3",
    "DT5",
    "DTN",
  ];
  const rnaResidues = [
    "GUA",
    "CYT",
    "URA",
    "ADE",
    "A",
    "A3",
    "A5",
    "AN",
    "C",
    "C3",
    "C5",
    "CN",
    "G",
    "G3",
    "G5",
    "GN",
    "OHE",
    "U",
    "U3",
    "U5",
    "UN",
  ];
  const membraneResidues = ["POPC", "POPE", "POPS", "PHPC", "DOPC", "DOPE", "DOPS", "DMPC", "CHOL", "LHD", "LTL"];
  const waterResidues = ["WAT", "HOH", "TIP","SOL"];
  const ligandResidues = [
    "STI",
    "LIG",
    "RES",
    "IBU",
    "ATP",
    "ADP",
    "AMP",
    "GTP",
    "GDP",
    "FAD",
    "NAD",
    "NADP",
    "FMN",
    "HEM",
    "COA",
    "GSH",
    "THF",
    "SO4",
    "PO4",
    "ZN",
    "MG",
    "CA",
    "CL",
    "NA",
    "K",
    "FE",
    "CU",
    "MN",
    "NO3",
    "H2O",
    "HOH",
    "CD",
    "HG",
    "OH",
    "DMS",
    "EDO",
    "GOL",
    "PEG",
    "PLM",
    "OLA",
    "MYR",
    "BME",
    "BGC",
    "MAN",
    "NAG",
    "FUC",
    "GAL",
    "TRE",
    "XMP",
    "SAH",
    "SAM",
  ];
  const backboneAtoms = [
    "O5'",
    "P",
    "O3'",
    "C5'",
    "C4'",
    "C3'",
    "N",
    "CA",
    "C",
    "CVC",
    "CVD",
    "CVS",
    "CVQ",
    "CVK",
    "CVI",
    "CVP",
    "CVT",
    "CVF",
    "CVN",
    "CVG",
    "CVH",
    "CVL",
    "CVR",
    "CVW",
    "CVA",
    "CVV",
    "CVE",
    "CVY",
    "CVM",
  ];

  selection = selection.trim().replaceAll("\\'", "'");
  console.log(selection);

  // Check if the selection is "all"
  if (selection.trim().toLowerCase() === "all") {
    return Array.from({ length: pdb.names.length }, (_, i) => i);
  }

  // Helper function to parse the selection string
  function parseSelection(selection) {
    const conditions = [];
    const parts = selection.split(/\s+(and|or|not)\s+/);

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i].trim();

      if (part === "and" || part === "or" || part === "not") {
        conditions.push({ operator: part });
      } else if (part.toLowerCase() === "protein") {
        conditions.push({ key: "protein", type: "protein" });
      } else if (part.toLowerCase() === "nucleic") {
        conditions.push({ key: "nucleic", type: "nucleic" });
      } else if (part.toLowerCase() === "dna") {
        conditions.push({ key: "dna", type: "dna" });
      } else if (part.toLowerCase() === "rna") {
        conditions.push({ key: "rna", type: "rna" });
      } else if (part.toLowerCase() === "ligand") {
        conditions.push({ key: "ligand", type: "ligand" });
      } else if (part.toLowerCase() === "lipid") {
        conditions.push({ key: "lipid", type: "lipid" });
      } else if (part.toLowerCase() === "membrane") {
        conditions.push({ key: "membrane", type: "membrane" });
      } else if (part.toLowerCase() === "water") {
        conditions.push({ key: "water", type: "water" });
      } else if (part.toLowerCase() === "backbone") {
        conditions.push({ key: "backbone", type: "backbone" });
      } else if (part.toLowerCase() === "sidechain") {
        conditions.push({ key: "sidechain", type: "sidechain" });
      } else {
        const [key, ...values] = part.split(/\s+/);
        if (key && values.length > 0) {
          if (values.length > 1) {
            if (values[1].includes("to")) {
              //was values[0] from chatGPT, I changed it to 1 which makes sense
              // Handle range condition
              //const [start, end] = values[0].split("to").map(Number);    //was like this, I changed it the two next lines
              const start = values[0];
              const end = values[2];
              conditions.push({ key, type: "range", start, end });
            } else {
              // Handle list condition
              conditions.push({
                key,
                type: "list",
                values: values.map((value) => (isNaN(value) ? value.trim() : Number(value))),
              });
            }
          } else {
            // Handle single value or special conditions
            const value = values[0];
            if (value.startsWith("within")) {
              const [distance, , reference] = value.split(/\s+/);
              conditions.push({ key, type: "within", distance: Number(distance), reference });
            } else {
              conditions.push({ key, type: "value", value: isNaN(value) ? value.trim() : Number(value) });
            }
          }
        } else {
          conditions.push({ key, type: "single", value: part });
        }
      }
    }
    return conditions;
  }

  // Helper function to check if an atom matches a single condition
  function matchesCondition(atomIndex, condition) {
    switch (condition.key) {
      case "name":
        return condition.type === "list"
          ? condition.values.includes(pdb.names[atomIndex])
          : pdb.names[atomIndex] === condition.value;
      case "element":
        return condition.type === "list"
          ? condition.values.includes(pdb.elements[atomIndex])
          : pdb.elements[atomIndex] === condition.value;
      case "resname":
        return condition.type === "list"
          ? condition.values.includes(pdb.resnames[atomIndex])
          : pdb.resnames[atomIndex] === condition.value;
      case "resid":
        if (condition.type === "range") {
          return pdb.resnos[atomIndex] >= condition.start && pdb.resnos[atomIndex] <= condition.end;
        } else if (condition.type === "list") {
          return condition.values.includes(pdb.resnos[atomIndex]);
        } else {
          return pdb.resnos[atomIndex] == condition.value;
        }
      case "chain":
        return condition.type === "list"
          ? condition.values.includes(pdb.chains[atomIndex])
          : pdb.chains[atomIndex] === condition.value;
      case "protein":
        return proteinResidues.includes(pdb.resnames[atomIndex]);
      case "nucleic":
        return nucleicResidues.includes(pdb.resnames[atomIndex]);
      case "dna":
        return dnaResidues.includes(pdb.resnames[atomIndex]);
      case "rna":
        return rnaResidues.includes(pdb.resnames[atomIndex]);
      case "lipid":
        return membraneResidues.includes(pdb.resnames[atomIndex]);
      case "membrane":
        return membraneResidues.includes(pdb.resnames[atomIndex]);
      case "ligand":
        return ligandResidues.includes(pdb.resnames[atomIndex]);
      case "water":
        return waterResidues.includes(pdb.resnames[atomIndex]);
      case "backbone":
        return backboneAtoms.includes(pdb.names[atomIndex]);
      case "sidechain":
        return !backboneAtoms.includes(pdb.names[atomIndex]);
      case "within":
        // Examples to test this:
        //                           show atoms within 5 of nucleic acids as spheres
        //                           show everything that's close to chain A as spheres
        return atomIsWithin(atomIndex, condition.values[0], condition.values.slice(2).join(" ")); //.values[2]);   //posicion, distance limit, string to check if it's close to
      default:
        return false;
    }
  }

  function atomIsWithin(atomIndex, distance, referenceString) {
    //index of atom to test, distance limit, string to check if it's close to it

    //If the tested atom would be contained in the reference string, just don't return it!
    if (
      (referenceString === "nucleic" && nucleicResidues.includes(pdb.resnames[atomIndex])) ||
      (referenceString === "protein" && proteinResidues.includes(pdb.resnames[atomIndex])) ||
      (referenceString === "dna" && dnaResidues.includes(pdb.resnames[atomIndex])) ||
      (referenceString === "rna" && rnaResidues.includes(pdb.resnames[atomIndex])) ||
      (referenceString === "membrane" && membraneResidues.includes(pdb.resnames[atomIndex])) ||
      (referenceString === "water" && waterResidues.includes(pdb.resnames[atomIndex])) ||
      (referenceString === "ligand" && ligandResidues.includes(pdb.resnames[atomIndex]))
    ) {
      return false;
    }

    if (referenceString.substring(0, 5) === "chain") {
      const allchains = referenceString.substring(6).trim().split(" ");
      if (allchains.includes(pdb.chains[atomIndex])) {
        return false;
      }
    }

    // Loop over all atoms in the pdb structure
    for (let ii = 0; ii < pdb.positions.length; ii++) {
      if (
        (referenceString === "nucleic" && nucleicResidues.includes(pdb.resnames[ii])) ||
        (referenceString === "protein" && proteinResidues.includes(pdb.resnames[ii])) ||
        (referenceString === "dna" && dnaResidues.includes(pdb.resnames[ii])) ||
        (referenceString === "rna" && rnaResidues.includes(pdb.resnames[ii])) ||
        (referenceString === "membrane" && membraneResidues.includes(pdb.resnames[ii])) ||
        (referenceString === "water" && waterResidues.includes(pdb.resnames[ii])) ||
        (referenceString === "ligand" && ligandResidues.includes(pdb.resnames[ii]))
      ) {
        const dx = pdb.positions[ii].x - pdb.positions[atomIndex].x;
        const dy = pdb.positions[ii].y - pdb.positions[atomIndex].y;
        const dz = pdb.positions[ii].z - pdb.positions[atomIndex].z;
        const dist = Math.sqrt(dx * dx + dy * dy + dz * dz);

        if (dist <= distance) {
          return true;
        }
      }
      if (referenceString.substring(0, 5) === "chain") {
        const allchains = referenceString.substring(6).trim().split(" ");
        if (allchains.includes(pdb.chains[ii])) {
          const dx = pdb.positions[ii].x - pdb.positions[atomIndex].x;
          const dy = pdb.positions[ii].y - pdb.positions[atomIndex].y;
          const dz = pdb.positions[ii].z - pdb.positions[atomIndex].z;
          const dist = Math.sqrt(dx * dx + dy * dy + dz * dz);

          if (dist <= distance) {
            return true;
          }
        }
      }
    }
    return false;
  }

  // Helper function to evaluate conditions with logical operators
  function evaluateConditions(atomIndex, conditions) {
    let result = matchesCondition(atomIndex, conditions[0]);
    for (let i = 1; i < conditions.length; i += 2) {
      const operator = conditions[i].operator;
      const nextCondition = conditions[i + 1];
      if (operator === "and") {
        result = result && matchesCondition(atomIndex, nextCondition);
      } else if (operator === "or") {
        result = result || matchesCondition(atomIndex, nextCondition);
      } else if (operator === "not") {
        result = result && !matchesCondition(atomIndex, nextCondition);
      }
    }
    return result;
  }

  const conditions = parseSelection(selection);

  // Collect the indexes of atoms that match the conditions
  const selectedAtomIndexes = [];
  for (let i = 0; i < pdb.names.length; i++) {
    if (evaluateConditions(i, conditions)) {
      selectedAtomIndexes.push(i);
    }
  }

  console.log("From selection function:\n\n" + selectedAtomIndexes);

  return selectedAtomIndexes;
}

export async function speakup(TextToSpeak) {
  if ("speechSynthesis" in window) {
    try {
      console.log("Attempting to speak:", TextToSpeak);
      await speakText(TextToSpeak);
      console.log("Speech finished successfully.");
    } catch (error) {
      console.error("Speech synthesis failed:", error);
    }
  } else {
    console.log("Speech synthesis not supported by browser.");
  }
}

function speakText(text) {
  return new Promise((resolve, reject) => {
    if (!text || text.trim().length === 0) {
        console.warn("Attempted to speak empty text.");
        return resolve();
    }
    // Optional: Cancel any ongoing speech before speaking new text
    if (window.speechSynthesis.speaking) {
        console.log("Cancelling ongoing speech before speaking new text.");
        window.speechSynthesis.cancel();
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US"; 
    utterance.onend = () => {
      console.log("Speech utterance ended for:", text);
      resolve();
    };

    utterance.onerror = (event) => {
      console.error("SpeechSynthesis Utterance Error:", event.error, "for text:", text);
      reject(event.error); 
    };

    // Add a small delay before speaking, sometimes helps browsers
    setTimeout(() => {
        try {
            window.speechSynthesis.speak(utterance);
            console.log("Called speechSynthesis.speak for:", text);
        } catch (e) {
            console.error("Error calling speechSynthesis.speak:", e);
            reject(e); // Reject if the initial call throws an error
        }
    }, 50); // Small delay like 50ms

  });
}